<template lang="pug">
  div
    div(class="d-flex justify-center w-100 mb-4")
      v-img(
        :src="require('~/assets/images/debit-card.png')"
        max-width="105"
      )
    h2(class="title-32px fw-700 mb-8") {{ $t('Add card') }}
    div(id="tranzzo-widget")
    div(
      v-if="loading"
      class="d-flex align-center justify-center pa-10"
    )
      e-progress-circular(
        size="xl"
        width="4"
      )
</template>

<script>
import EProgressCircular from '~/components/elements/progress/e-progress-circular'
import informationSnackbar from '~/modules/snackbar/mixins/informationSnackbar'
export default {
  name: 'BlockTranzzoGenerateToken',
  components: {
    EProgressCircular
  },
  mixins: [informationSnackbar],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    activeCardId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      tranzzoWidget: null,
      loading: false,
      tokenData: null
    }
  },
  watch: {
    tokenData(val) {
      if (val) {
        this.setCardToken(this.tokenData)
      }
    }
  },
  mounted() {
    this.loading = true
    this.tranzzoInit()
    document.addEventListener('widget-init-ready', this.setWidgetLoading)
  },
  beforeDestroy() {
    document.removeEventListener('widget-init-ready', this.setWidgetLoading)
  },
  methods: {
    tranzzoInit() {
      if (!document.body.querySelector('script[src="https://gcdn.tranzzo.com/widget.js"]')) {
        const script = document.createElement('script')
        script.src = 'https://gcdn.tranzzo.com/widget.js'
        script.async = true
        script.onload = () => this.onScriptLoaded(this)

        document.body.appendChild(script)
      } else {
        this.onScriptLoaded(this)
      }
    },
    onScriptLoaded(componentInstance) {
      window.Tranzzo.init({
        key: componentInstance.$config.tranzzoApiToken,
        mode: 'inline',
        style: 'dubidoc',
        template: 'default',
        lang: 'uk',
        selector: 'tranzzo-widget',
        locale: {
          uk: {
            submit: 'Зберегти картку'
          }
        },
        onToken(tokenData) {
          componentInstance.tokenData = tokenData
        }
      }).open()
    },
    async setCardToken(data) {
      try {
        this.loading = true
        if (this.activeCardId) {
          await this.$store.dispatch('tranzzo/delete', this.activeCardId)
        }
        await this.$store.dispatch('tranzzo/create', {
          payload: {
            token: data.token,
            cardMask: data.card_mask,
            source: 'tranzzo',
            paymentSystem: data.issuer.payment_system,
            expiredAt: data.expires_at
          }
        })
        this.informationSnackbar.open({
          icon: 'check-circle-white-filled',
          text: this.$t('Card has been added for autopayment')
        })
        this.closeModal(true)
      } catch (e) {
        this.$handlers.error(e, this)
        this.closeModal(false)
      } finally {
        this.loading = false
      }
    },
    setWidgetLoading() {
      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
